import { render, staticRenderFns } from "./navigation-link-submenu.vue?vue&type=template&id=21d355fe&"
import script from "./navigation-link-submenu.vue?vue&type=script&lang=ts&"
export * from "./navigation-link-submenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports